/** Where to send someone after they sign in, carried as `?next=` on /login.
 *  Only a same-site path is accepted: it must start with one "/" (never "//"
 *  or "/\", which browsers read as another host) and must not point back at
 *  the auth pages. Anything else returns null and sign-in lands as before. */
export function safeNextPath(raw: string | null | undefined): string | null {
  if (!raw || raw.length > 2000) return null;
  if (!raw.startsWith("/") || raw.startsWith("//") || raw.startsWith("/\\")) return null;
  if (/^\/(login|register|auth-callback)(\/|\?|$)/.test(raw)) return null;
  return raw;
}

/** `/login`, or `/login?next=<path>` when `path` is a safe return target. */
export function loginPathFor(path: string | null | undefined): string {
  const next = safeNextPath(path);
  return next && next !== "/" ? `/login?next=${encodeURIComponent(next)}` : "/login";
}
